<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/fertilization/budgeted_cards/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('fertilization.budgeted_card_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :resizable="false"
                :align="'center'"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="120"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route: 'fertilization/budgeted_cards/pdf',
                  name_file: 'cedulas_presupuestadas.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route: 'fertilization/budgeted_cards/excel',
                  name_file: 'cedulas_presupuestadas.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4" v-if="viewDetails">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-12 text-center">
            <h6 class="text-muted">
              {{ $t('fertilization.fertilization_budgeted_card_details') }} -
              {{ budgetedCardForm.year }}
            </h6>
          </div>
        </div>
        <br />
        <div v-if="isIndex()">
          <div class="col-sm-12">
            <el-table
              stripe
              :data="tableViewData"
              :span-method="arraySpanMethod"
              :row-class-name="tableRowClassName"
              :cell-class-name="tableCellClassName"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                min-width="150"
                prop="fertilizer"
                :label="$t('fertilization.fertilizer')"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="number_packages"
                :label="$t('production.bundle_quantity')"
                :formatter="formatterNumber"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="number_packages_kg"
                :label="$t('production.bundle_quantity_unit')"
                :formatter="formatterNumber"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="package_value"
                :label="$t('production.bundle_value')"
                :formatter="formatterNumber"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="number_packages_ha"
                :label="$t('production.bundles_per_ha')"
                :formatter="formatterNumber"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="package_value_ha"
                :label="$t('production.bundle_value_per_ha')"
                :formatter="formatterNumber"
              ></el-table-column>
              <el-table-column
                :label="$t('samples.nutrient_contribution_unit')"
              >
                <el-table-column
                  v-for="column in nutrientColumns"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  :formatter="formatterNumber"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                  min-width="75"
                >
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route:
                    'fertilization/budgeted_cards/pdf/' + budgetedCardForm.id,
                  name_file: 'cedula_presupuestada.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route:
                    'fertilization/budgeted_cards/excel/' + budgetedCardForm.id,
                  name_file: 'cedula_presupuestada.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import configTable from './budgetedCardTable';

export default {
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      budgetedCardForm: {},
      tableViewData: null,
      viewDetails: false,
      nutrientColumns: [],
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        this.budgetedCardForm.type == 'Lote' &&
        (rowIndex === this.tableViewData.length - 2 ||
          rowIndex === this.tableViewData.length - 1)
      ) {
        if (columnIndex === 0) {
          return [1, 6];
        } else if ([1, 2, 3, 4, 5].includes(columnIndex)) {
          return [1, 0];
        }
      }
    },

    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        this.budgetedCardForm.type == 'Lote' &&
        (rowIndex === this.tableViewData.length - 3 ||
          rowIndex === this.tableViewData.length - 2 ||
          rowIndex === this.tableViewData.length - 1)
      ) {
        return 'bold-cellfer';
      } else if (
        this.budgetedCardForm.type != 'Lote' &&
        rowIndex === this.tableViewData.length - 1
      ) {
        return 'bold-cellfer';
      }
      return '';
    },

    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      return '';
    },

    handleView(index, row) {
      this.showHideLoading(true);

      this.tableViewData = [];
      this.budgetedCardForm = Object.assign({}, row);

      if (this.budgetedCardForm.budgeted_card_fertilizer.length > 0) {
        let nutrientsColunm = [];
        let nutrients_ids = [];
        let nutrients_symbols = [];

        this.budgetedCardForm.budgeted_card_fertilizer.forEach((element) => {
          let datafer = {};

          datafer.fertilizer = element.fertilizer.name;
          datafer.number_packages = Number(element.number_packages).toFixed(1);
          datafer.number_packages_kg = Number(
            element.number_packages * element.fertilizer.conversion_factor
          ).toFixed(1);
          datafer.package_value = Number(element.package_value).toFixed(1);
          datafer.number_packages_ha = Number(
            datafer.number_packages_kg / this.budgetedCardForm.hectares
          ).toFixed(1);
          datafer.package_value_ha = Number(
            datafer.number_packages_ha * element.package_value
          ).toFixed(1);

          element.fertilizer.fertilizer_nutrients.forEach(
            (fertilizer_nutrient) => {
              let propname = fertilizer_nutrient.nutrient.symbol.trim();
              propname = propname.toLowerCase();

              let columnsexits = nutrientsColunm.map((colum) => {
                return colum.prop;
              });

              if (!columnsexits.includes(propname)) {
                nutrientsColunm.push({
                  label: fertilizer_nutrient.nutrient.symbol,
                  prop: propname,
                });
                nutrients_ids.push(fertilizer_nutrient.nutrient.id);
                nutrients_symbols.push(fertilizer_nutrient.nutrient.symbol);
              }

              datafer[propname] = parseFloat(
                (datafer.number_packages_ha * fertilizer_nutrient.percentage) /
                  100
              ).toFixed(2);
            }
          );

          this.nutrientColumns = nutrientsColunm;

          this.tableViewData.push(datafer);
        });

        let total_row = {};
        total_row.fertilizer = 'Total';
        total_row.number_packages = 0;
        total_row.number_packages_kg = 0;
        total_row.package_value = 0;
        total_row.number_packages_ha = 0;
        total_row.package_value_ha = 0;

        nutrientsColunm.forEach((column, index) => {
          total_row[column.prop] = 0;
        });

        this.tableViewData.forEach((view_row) => {
          total_row.number_packages += parseFloat(view_row.number_packages);
          total_row.number_packages_kg += parseFloat(
            view_row.number_packages_kg
          );
          total_row.package_value += parseFloat(view_row.package_value);
          total_row.number_packages_ha += parseFloat(
            view_row.number_packages_ha
          );
          total_row.package_value_ha += parseFloat(view_row.package_value_ha);

          nutrientsColunm.forEach((column, index) => {
            if (
              typeof total_row[column.prop] !== 'undefined' &&
              typeof view_row[column.prop] !== 'undefined'
            ) {
              total_row[column.prop] += parseFloat(view_row[column.prop]);
            }
          });
        });

        this.tableViewData.push(total_row);

        if (this.budgetedCardForm.type == 'Lote') {
          let request_data = {
            route: 'grounds/ranges/recommendations',
            nutrients_ids: nutrients_ids,
            nutrients_symbols: nutrients_symbols,
            year: String(this.budgetedCardForm.year),
            lot_id: this.budgetedCardForm.lot_id,
            farm_id: this.budgetedCardForm.farm_id,
          };

          let datafer = {};

          Axios.saveMaster(request_data)
            .then((response1) => {
              this.budgetedCardForm.recommendations = response1.data;

              datafer.fertilizer = 'Recomendado';
              datafer.number_packages = null;
              datafer.number_packages_kg = null;
              datafer.package_value = null;
              datafer.number_packages_ha = null;
              datafer.package_value_ha = null;

              nutrientsColunm.forEach((column, index) => {
                datafer[column.prop] =
                  this.budgetedCardForm.recommendations[index];
              });

              this.tableViewData.push(datafer);

              let datafer1 = {};

              datafer1.fertilizer = 'Diferencia';
              datafer1.number_packages = null;
              datafer1.number_packages_kg = null;
              datafer1.package_value = null;
              datafer1.number_packages_ha = null;
              datafer1.package_value_ha = null;

              nutrientsColunm.forEach((column, index) => {
                if (
                  this.budgetedCardForm.recommendations[index] &&
                  parseFloat(this.budgetedCardForm.recommendations[index]) > 0
                ) {
                  datafer1[column.prop] =
                    this.budgetedCardForm.recommendations[index] -
                    total_row[column.prop];
                } else {
                  datafer1[column.prop] =
                    this.budgetedCardForm.recommendations[index];
                }
              });

              this.tableViewData.push(datafer1);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showMessageErrors(error);
              this.showHideLoading();
            });
        } else {
          this.showHideLoading();
        }
      } else {
        this.showHideLoading();
      }
      this.viewDetails = true;

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    },

    handleEdit(index, row) {
      row.url_path_form = '/fertilization/budgeted_cards/edit';
      this.moduleForm = Object.assign({}, row);
      this.moduleForm.roles = row.roles_ids;
      sessionStorage.setItem('editForm', JSON.stringify(this.moduleForm));
      this.$router.push({ path: '/fertilization/budgeted_cards/edit' });
    },

    handleDelete(index, row) {
      this.viewDetails = false;
      this.budgetedCardForm = row;
      SweetAlert.delete(this.budgetedCardForm.year).then((result) => {
        if (result.value) this.deleteBudgetedCard();
      });
    },

    deleteBudgetedCard() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.budgetedCardForm.route = 'fertilization/budgeted_cards';
        Axios.destroyMaster(this.budgetedCardForm)
          .then((response) =>
            this.modifyTable(2, this.budgetedCardForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('fertilization/budgeted_cards')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = response.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
<style></style>
